import store from "@store/index";
let mobileFn = store._mutations["wallet/SET_ISMOBILE"][0];
// console.log(isMobile)
function setRem() {
  let _isMobile = false;
  let htmlWidth = null;
  htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  //得到html的Dom元素
  let htmlDom = document.getElementsByTagName("html")[0];
  let sUserAgent = navigator.userAgent.toLowerCase();
  console.log("location", location);
  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
    //wap
    _isMobile = true;

    htmlDom.style.fontSize = htmlWidth / 3 + "px";
  } else {
    _isMobile = false;
    if(location.pathname== '/purchase') {
      htmlDom.style.fontSize ="188px";
    }else {
      htmlDom.style.fontSize = htmlWidth / 10.5 + "px";
    }
    if (htmlWidth <= 980) {
      _isMobile = true;
      htmlDom.style.fontSize = htmlWidth / 3 + "px";
    }
  }
  mobileFn(_isMobile);
}

function throttle(fn, delay) {
  var timer = null;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

// 初始化
setRem(true);
// 改变窗口大小时重新设置 rem

window.onresize = throttle(setRem, 0);
